import React, { useContext } from "react";
import { AppContext } from "./index";

export default function Trash({ visible, setTrash }) {
  let { firebase } = useContext(AppContext);
  let actividades = firebase.proyectoActivo.actividades;

  function allowDrop(e) {
    e.preventDefault();
    e.target.style.transform = "scale(1.3) ";
  }

  function drop(e) {
    e.preventDefault();
    let data = JSON.parse(e.dataTransfer.getData("text"));

    if (data.obj === "usuario") {
      actividades[data.ind].asignados.splice(data.indUsr, 1);
      setTrash(false);
      return;
    }

    if (data.obj === "tarea") {
      if (actividades[data.ind].estado !== "") {
        // se marca para baja logica
        firebase.proyectoActivo.addBajaLogica(actividades[data.ind].id);
      }
      actividades.splice(data.ind, 1);
      setTrash(false);
      return;
    }
    setTrash(false);
  }

  function leaveDrag(e) {
    e.target.style.transform = "scale(1) ";
  }

  return (
    <div
      onDrop={(e) => drop(e)}
      onDragOver={(e) => allowDrop(e)}
      onDragLeave={(e) => leaveDrag(e)}
      draggable="true">
      {visible ? (
        <i
          className="material-icons icono36"
          style={Strash}

        >
          delete
        </i>
      ) : null}
    </div>
  );
}

const Strash = {
  position: "fixed",
  top: "93vh",
  left: "80%",
  border: "1px solid white",
  transition: "transform .2s",
  background: "black",
};
